module.exports = __webpack_public_path__ + "img/logo-leste.492f78c4.svg";